import { HomeCategory } from "../actions/types";
import { buildAssetUrl, TenantConfig } from "./tenantConfig";

export interface SaleBanner {
  /** ID del tipo de producto de la promo (para detectar si está activa). */
  typeId?: number;
  /** Imagen para mobile. "" si no hay archivo configurado. */
  image: string;
  /** Imagen para desktop. "" si no hay archivo configurado. */
  imageWide: string;
  /** Link del banner. */
  link: string;
}

/**
 * Banners de promociones disponibles para el tenant, en orden de prioridad.
 * Agregar aquí un nuevo evento de ventas (ej: Black Friday).
 */
export const buildSaleBanners = (tenant: TenantConfig): SaleBanner[] => [
  {
    typeId: tenant.hotSaleTypeId,
    image: buildAssetUrl(tenant.shopId, tenant.hotSaleImageMobileFile),
    imageWide: buildAssetUrl(tenant.shopId, tenant.hotSaleImageWideFile),
    link: tenant.hotSaleTypeId ? `/product-type/${tenant.hotSaleTypeId}` : "/",
  },
  {
    typeId: tenant.cyberMondayTypeId,
    image: buildAssetUrl(tenant.shopId, tenant.cyberMondayImageMobileFile),
    imageWide: buildAssetUrl(tenant.shopId, tenant.cyberMondayImageWideFile),
    link: tenant.cyberMondayTypeId
      ? `/product-type/${tenant.cyberMondayTypeId}`
      : "/",
  },
];

/**
 * Devuelve el banner de la promo activa en la home, o undefined si no hay ninguna.
 * Prioridad: Hot Sale, luego Cyber Monday.
 * La detección se hace por id_type (comparando con el typeId del tenant),
 * porque el title del backend puede no coincidir exactamente con la promo.
 */
export const findActiveSaleBanner = (
  tenant: TenantConfig,
  home_categories?: HomeCategory[],
): SaleBanner | undefined =>
  buildSaleBanners(tenant).find(
    (banner) =>
      banner.typeId &&
      home_categories?.some((category) => category.id_type === banner.typeId),
  );
